import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from 'vhobjects-service';
import { ChooseIconComponent } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';

import {
  BOOKING_FLOW_COLOR_GROUPS,
  COLOR_SECTIONS,
  DEFAULT_BOOKING_FLOW_THEME,
  LIST_COLOR_OPTIONS,
} from './booking-flow-theme.constants';
import { BOOKING_FLOW_LINK_SLOTS, CONTENT_SECTIONS, STYLES_FIELD } from './booking-flow-content.constants';

@Component({
  selector: 'atw-booking-flow-config',
  templateUrl: './booking-flow-config.component.html',
  styleUrls: ['./booking-flow-config.component.scss'],
})
export class AtwBookingFlowConfig implements OnInit {
  @Input() objectChoosing: any; // nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any;
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any; // lưu phần tử được chọn của mảng style_field để hiện thị phần mở rộng cấu hình
  backgroundColor: any = [];

  width: number = 0;
  height: number = 0;
  customize = [];

  // ===== Static config, imported from constants files =====
  readonly styles_field: any[] = STYLES_FIELD;
  readonly listColorOptions = LIST_COLOR_OPTIONS;
  readonly bookingFlowColorGroups = BOOKING_FLOW_COLOR_GROUPS;
  readonly colorSections = COLOR_SECTIONS;
  readonly sections: any[] = CONTENT_SECTIONS;
  readonly linkSlots = BOOKING_FLOW_LINK_SLOTS;

  bookingFlowTheme: any = { ...DEFAULT_BOOKING_FLOW_THEME };

  /** Trạng thái mở/đóng của từng nhóm màu */
  openColorGroup: { [key: string]: boolean } = {
    chung: true, // nhóm đầu tiên mở sẵn
  };

  /** Trạng thái mở/đóng của từng nhóm nội dung */
  openContentGroup: { [key: string]: boolean } = {
    chon_phong: true, // nhóm đầu tiên mở sẵn
  };

  /**
   * Hàm này dùng để cho phép mở menu config.
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false,
    menu6: false, menu7: false, menu8: false, menu9: false, menu10: false,
    menu11: false, menu12: false,
  };
  openMapSub: { [name: string]: boolean } = { menu1: false, menu2: false };
  arr_link_pages: any[] = [];

  constructor(
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public themeService: ThemeService,
    private dialog: MatDialog,
    private vhAlgorithm: VhAlgorithm,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (!this.config) {
      this.config = {};
    }
    if (!this.config['sample_data_mode']) {
      this.config['sample_data_mode'] = 'has_data';
    }

    this.bookingFlowTheme = this.buildThemeFromExistingClasses();
    this.loadLinkPages();
  }

  private loadLinkPages(): void {
    this.vhQueryAutoWeb
      .getPages_byFields({ type: { $in: ['blank', 'homepage', 'detail_product'] } })
      .then((pages: any) => {
        const langCode = this.functionService.selectedLanguageCode;
        const normalized = (pages || []).map((page: any) =>
          !page['name_' + langCode] && page.name
            ? { ...page, ['name_' + langCode]: page.name }
            : page
        );
        this.arr_link_pages = this.vhAlgorithm.sortVietnamesebyASC(normalized, 'name_' + langCode);
      });
  }

  getLinkSlotLabel(link: string): string {
    const langCode = this.functionService.selectedLanguageCode;
    const page = this.arr_link_pages.find((p) => p.link === link);
    return page ? (page['name_' + langCode] || page.name) : '';
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.width = document.getElementById(this.objectChoosing._id).clientWidth;
        this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      }
    }, 0);
  }

  /**
   * @param value : tên menu cần mở
   * @param isSub : true nếu là menu con (openMapSub)
   */
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach((key) => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width height của element sau khi thay đổi
   */
  changeWidthHeight(event): void {
    if (event.width) this.class['booking-flow']['width'] = event.width + 'px';
    if (event.height) this.class['booking-flow']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  updateClassAndConfig(): void {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) {
        this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      }
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) {
        this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      }
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) {
        this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      }
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text): void {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Cập nhật staticdata vào database. */
  updateStaticData(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => { });
  }

  /** Cập nhật Setups vào database. */
  updateSetups(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups })
      .then((bool) => { });
  }

  /** Hàm update config vào database. */
  updateConfig(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }

  /** Hàm update object vào database. */
  updateFields(value): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then((bool: any) => { });
  }

  /** Hàm update class vào database. */
  updateClass(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }

  /** Hàm này thực hiện thêm màu gradient vào array. */
  addGradient(value): void {
    if (/#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient['gradient_arr'].push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);
      this.updateBackgroundRgb();
    }
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index): void {
    if (this.config['background-color']['gradient_arr'].length > 1) {
      this.config['background-color']['gradient_arr'].splice(index, 1);
      this.updateBackgroundRgb();
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb(): void {
    if (this.config['background-color'].gradient_check) {
      this.class['booking-flow']['background-image'] =
        'linear-gradient(' +
        this.config['background-color']['gradient_direction'] +
        this.config['background-color']['gradient_arr'] +
        ')';
    } else {
      this.class['booking-flow']['background-image'] = 'none';
    }
    this.updateObject();
  }

  /** Hàm update object vào database. */
  updateObject(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => { });
  }

  /**
   * Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event): void {
    if (isPlatformBrowser(this.platformId)) {
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['booking-flow']['background-image'] =
        this.config['background-color'].gradient_type +
        '(' +
        this.config['background-color'].gradient_direction +
        this.config['background-color'].gradient_arr.join(',') +
        ')';
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event, classBg): void {
    if (isPlatformBrowser(this.platformId)) {
      const activeGradient = document.querySelector('.container-color .active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');

      const data_background = this.class[classBg];
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(
        data_background['background-color'],
      )}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }

  openDialogChooseIcon(config): void {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        config.icon_name = result.icon;
        this.updateConfig();
      }
    });
  }

  /* =========================================================
   * COLOR GROUP UPDATE / APPLY THEME
   * ========================================================= */

  /**
   * Writes `bookingFlowTheme[type]` into every style-class it's mapped to.
   * @param persist  When true (default), immediately persists via updateClass().
   *                 Pass false when applying many keys in a batch (see
   *                 so only a single API call fires
   *                 at the end instead of one per key.
   */
  updateGroupColor(type: string, persist: boolean = true): void {
    const group = this.bookingFlowColorGroups[type];
    if (!group) {
      return;
    }
    const value = this.bookingFlowTheme[type];
    group.classes.forEach((className: string) => {
      if (!this.class[className]) {
        this.class[className] = {};
      }
      this.class[className][group.property] = value;
    });

    // Secondary style-class targets not covered by the main group mapping
    switch (type) {
      case 'roomCardSelectedBorder':
        this.class['choose-room__card-selected']['border-color'] = value;
        break;
      case 'roomCardButtonSelected':
        this.class['choose-room__select-btn-selected']['background-color'] = value;
        break;
      case 'roomCardButtonSelectedText':
        this.class['choose-room__select-btn-selected']['color'] = value;
        break;
      case 'addonCardSelectedBorder':
        this.class['add-ons__item-selected']['border-color'] = value;
        this.class['add-ons__check-input']['accent-color'] = value;
        break;
      case 'addonCheckColor':
        this.class['add-ons__check-input']['accent-color'] = value;
        break;
      case 'inputBorder':
        this.class['payment__phone-select']['border-color'] = value;
        this.class['payment__phone-input']['border-color'] = value;
        break;
      case 'summaryButton':
        this.class['payment__action-btn']['background-color'] = value;
        break;
      case 'summaryButtonText':
        this.class['payment__action-btn']['color'] = value;
        break;
    }

    if (persist) {
      this.updateClass();
    }
  }

  /* =========================================================
   * COLOR GROUP UI STATE
   * ========================================================= */

  toggleColorGroup(title: string): void {
    this.openColorGroup[title] = !this.openColorGroup[title];
  }

  isColorGroupOpen(title: string): boolean {
    return !!this.openColorGroup[title];
  }

  getColorLabel(key: string): string {
    return this.listColorOptions.find((o) => o.key === key)?.label || key;
  }

  toggleContentGroup(title: string): void {
    this.openContentGroup[title] = !this.openContentGroup[title];
  }

  isContentGroupOpen(title: string): boolean {
    return !!this.openContentGroup[title];
  }

  /* =========================================================
   * PRIVATE HELPERS
   * ========================================================= */

  /** Builds the initial theme object from whatever is already saved in `this.class` */
  private buildThemeFromExistingClasses(): any {
    return {
      background: this.class['booking-flow']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.background,

      cards: this.class['choose-room__panel']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.cards,
      borders: this.class['choose-room__panel']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.borders,
      divider: this.class['summary__section']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.divider,

      headerBackground: this.class['choose-room__header']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.headerBackground,
      headerBorder: this.class['choose-room__header']?.['border-bottom-color'] || DEFAULT_BOOKING_FLOW_THEME.headerBorder,
      headerTitle: this.class['choose-room__title']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.headerTitle,

      roomCardBackground: this.class['choose-room__card']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardBackground,
      roomCardBorder: this.class['choose-room__card']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardBorder,
      roomCardSelectedBorder: this.class['choose-room__card-selected']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardSelectedBorder,

      roomCardTitle: this.class['choose-room__name']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardTitle,
      roomCardDescription: this.class['choose-room__desc']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardDescription,
      roomCardMeta: this.class['choose-room__meta']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardMeta,

      roomCardPrice: this.class['choose-room__price-line']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardPrice,

      roomCardButton: this.class['choose-room__select-btn']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardButton,
      roomCardButtonText: this.class['choose-room__select-btn']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardButtonText,

      roomCardButtonSelected: this.class['choose-room__select-btn-selected']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardButtonSelected,
      roomCardButtonSelectedText: this.class['choose-room__select-btn-selected']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.roomCardButtonSelectedText,
      emptyStateBackground: this.class['choose-room__empty']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.emptyStateBackground,
      emptyStateText: this.class['choose-room__empty']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.emptyStateText,

      addonCardBackground: this.class['add-ons__item']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.addonCardBackground,
      addonCardBorder: this.class['add-ons__item']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.addonCardBorder,
      addonCardSelectedBorder: this.class['add-ons__item-selected']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.addonCardSelectedBorder,
      addOnRoomLabel: this.class['add-ons__room-label']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.addOnRoomLabel,
      addOnRoomName: this.class['add-ons__room-name']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.addOnRoomName,
      addonTitle: this.class['add-ons__item-title']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.addonTitle,
      addonPrice: this.class['add-ons__item-price']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.addonPrice,
      addonCheckColor: this.class['add-ons__check']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.addonCheckColor,

      paymentTitle: this.class['payment__title']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.paymentTitle,
      paymentText: this.class['payment__hint']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.paymentText,

      inputBackground: this.class['payment__input']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.inputBackground,
      inputText: this.class['payment__input']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.inputText,
      inputBorder: this.class['payment__input']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.inputBorder,
      inputLabel: this.class['payment__field-label']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.inputLabel,

      summaryBackground: this.class['summary__addons']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.summaryBackground,
      summaryBorder: this.class['summary__card']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.summaryBorder,

      summaryTitle: this.class['summary__section-title']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.summaryTitle,
      summaryText: this.class['summary__section-text']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.summaryText,

      summaryAmount: this.class['summary__amount']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.summaryAmount,
      summaryTotal: this.class['summary__total-amount']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.summaryTotal,
      summaryLabel: this.class['summary__total-label']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.summaryLabel,
      summaryButton: this.class['summary__action-btn']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.summaryButton,
      summaryButtonText: this.class['summary__action-btn']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.summaryButtonText,

      voucherInputBackground: this.class['summary__voucher-input']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.voucherInputBackground,
      voucherInputText: this.class['summary__voucher-input']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.voucherInputText,
      voucherInputBorder: this.class['summary__voucher-input']?.['border-color'] || DEFAULT_BOOKING_FLOW_THEME.voucherInputBorder,
      voucherButtonBackground: this.class['summary__voucher-btn']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.voucherButtonBackground,
      voucherButtonText: this.class['summary__voucher-btn']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.voucherButtonText,
      voucherAppliedBackground: this.class['summary__voucher-applied']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.voucherAppliedBackground,
      voucherAppliedText: this.class['summary__voucher-applied']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.voucherAppliedText,
      voucherRemoveText: this.class['summary__voucher-remove']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.voucherRemoveText,
      voucherErrorText: this.class['summary__voucher-message']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.voucherErrorText,
      discountAmountText: this.class['summary__discount-amount']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.discountAmountText,

      linkColor: this.class['choose-room__link']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.linkColor,

      iconColor: this.class['choose-room__meta-icon']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.iconColor,

      sliderNavBackground: this.class['choose-room__nav']?.['background-color'] || DEFAULT_BOOKING_FLOW_THEME.sliderNavBackground,
      sliderNavIcon: this.class['choose-room__nav']?.['color'] || DEFAULT_BOOKING_FLOW_THEME.sliderNavIcon,

      roomListBackground: DEFAULT_BOOKING_FLOW_THEME.roomListBackground,
      roomMediaBackground: DEFAULT_BOOKING_FLOW_THEME.roomMediaBackground,
      roomImageBorder: DEFAULT_BOOKING_FLOW_THEME.roomImageBorder,
      addonImageBackground: DEFAULT_BOOKING_FLOW_THEME.addonImageBackground,
      addonToggleBackground: DEFAULT_BOOKING_FLOW_THEME.addonToggleBackground,
      addonToggleText: DEFAULT_BOOKING_FLOW_THEME.addonToggleText,
      paymentDivider: DEFAULT_BOOKING_FLOW_THEME.paymentDivider,
      paymentMethodLabel: DEFAULT_BOOKING_FLOW_THEME.paymentMethodLabel,
      paymentMethodSubtitle: DEFAULT_BOOKING_FLOW_THEME.paymentMethodSubtitle,
      paymentNoteText: DEFAULT_BOOKING_FLOW_THEME.paymentNoteText,
      paymentNoteLink: DEFAULT_BOOKING_FLOW_THEME.paymentNoteLink,
      paymentRequired: DEFAULT_BOOKING_FLOW_THEME.paymentRequired,
      inputFocusBorder: DEFAULT_BOOKING_FLOW_THEME.inputFocusBorder,
      inputPlaceholder: DEFAULT_BOOKING_FLOW_THEME.inputPlaceholder,
      phoneSelectBackground: DEFAULT_BOOKING_FLOW_THEME.phoneSelectBackground,
      phoneSelectText: DEFAULT_BOOKING_FLOW_THEME.phoneSelectText,
      phoneSelectBorder: DEFAULT_BOOKING_FLOW_THEME.phoneSelectBorder,
      primaryButtons: DEFAULT_BOOKING_FLOW_THEME.primaryButtons,
      primaryButtonText: DEFAULT_BOOKING_FLOW_THEME.primaryButtonText,
      secondaryButtons: DEFAULT_BOOKING_FLOW_THEME.secondaryButtons,
      secondaryButtonBorder: DEFAULT_BOOKING_FLOW_THEME.secondaryButtonBorder,
      secondaryButtonText: DEFAULT_BOOKING_FLOW_THEME.secondaryButtonText,
      buttonHover: DEFAULT_BOOKING_FLOW_THEME.buttonHover,
      backButtonBackground: DEFAULT_BOOKING_FLOW_THEME.backButtonBackground,
      backButtonIcon: DEFAULT_BOOKING_FLOW_THEME.backButtonIcon,
      summaryNote: DEFAULT_BOOKING_FLOW_THEME.summaryNote,
      summaryLink: DEFAULT_BOOKING_FLOW_THEME.summaryLink,
      linkHover: DEFAULT_BOOKING_FLOW_THEME.linkHover,
    };
  }
}